import { render, staticRenderFns } from "./QueueList.vue?vue&type=template&id=710128fa&"
import script from "./QueueList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./QueueList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports